<template>
	<div class="qiye">
		<ul>
			<li class="qiye_list" v-for="(item,index) in enterprises" :key="index">
				<router-link :to="{ path:'/qiyeDetails',query:{ id:item.id }}" class="qiye_list_router">
					<div class="qiye_top">
							<div class="qiye_img" :style="{'backgroundImage':'url('+item.img+')'}"></div>
							<div>{{ item.title }}</div>
					</div>
					<div><p>机构标语：</p><p class="qiye_content">{{ item.summary }}</p></div>
					<div class="qiye_bottom">机构联系方式：{{ item.phone }}</div>
					<div class="qiye_bottom">入驻时间：{{ item.created_at }}</div>
				</router-link>
			</li>
		</ul>
	</div>
</template>
<script>
export default {
	metaInfo: {
		title: "拍界——唤醒您的沉睡资产",
		meta: [{
			name: "keywords",
			content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}, {
			name: "description",
			content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}]
	},
	data (){
		return{
			enterprises: []
		}
	 },
	created(){
		// 显示公共栏
		this.$emit('header', true)
		this.$emit('footer', true)
		// 请求页面数据
		this.axios.get(this.$global.apiUrl.enterprises)
		.then((response) => {
			if(response.data.error.code == 0){
				this.enterprises = response.data.enterprises;
			}else{

			}
		})
		.catch(() => {
				// console.log(response.data.error.message)
		})
		// 页面至顶部
		window.scrollTo(0,0);
	},
	mounted(){
		// console.log('Current Swiper instance object', this.mySwiper);
	},
	computed: {

	}
}
</script>